import React, { useEffect, useState } from "react";
import { msUntilNextIstMidnight, formatCountdown } from "../lib/ist";

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="font-mono-ac text-2xl sm:text-4xl font-bold ac-gold-text tabular-nums">
      {String(value).padStart(2, "0")}
    </div>
    <div className="text-[10px] sm:text-xs uppercase tracking-widest text-zinc-500">{label}</div>
  </div>
);

export const Countdown = ({ onReset }) => {
  const [ms, setMs] = useState(msUntilNextIstMidnight());

  useEffect(() => {
    const id = setInterval(() => {
      const next = msUntilNextIstMidnight();
      setMs(next);
      if (next <= 1000 && onReset) setTimeout(() => onReset(), 1200);
    }, 1000);
    return () => clearInterval(id);
  }, [onReset]);

  const { hrs, mins, secs } = formatCountdown(ms);
  return (
    <div data-testid="next-movie-countdown" className="text-center">
      <div className="text-xs uppercase tracking-[0.25em] text-zinc-400 mb-2">Next Movie In</div>
      <div className="flex items-center justify-center gap-3 sm:gap-5">
        <Unit value={hrs} label="hrs" />
        <span className="text-2xl sm:text-4xl ac-gold-text font-bold pb-4">:</span>
        <Unit value={mins} label="mins" />
        <span className="text-2xl sm:text-4xl ac-gold-text font-bold pb-4">:</span>
        <Unit value={secs} label="secs" />
      </div>
    </div>
  );
};
